import classNames from "classnames";
import { ArrowRightRounded } from "shared/components/Svg/Icons/Outline";
import { STATUS_TYPES } from "utils/constants";

const STATUS_CONFIG = {
  [STATUS_TYPES.ACTIVE]: { color: "green", label: "Active", dot: true },
  [STATUS_TYPES.INACTIVE]: { color: "gray", label: "Inactive", dot: true },
  [STATUS_TYPES.COMPLETED]: { color: "green", label: "Completed", dot: true },
  [STATUS_TYPES.PENDING]: { color: "orange", label: "Pending", dot: true },
  [STATUS_TYPES.REJECTED]: { color: "gray", label: "Rejected", dot: true },
  [STATUS_TYPES.VERIFIED]: { color: "blue", label: "Verified", dot: true },
  [STATUS_TYPES.LOCKED]: { color: "orange", label: "Locked", dot: true },
  [STATUS_TYPES.ENABLED]: { color: "purple", label: "Enabled", dot: true },
};
const SIZES = {
  SMALL: { mode: "small", value: 14 },
  MEDIUM: { mode: "medium", value: 16 },
  LARGE: { mode: "large", value: 20 },
};
const VARIANTS = { DOT: "dot", ARROW: "arrow" };

function Status({
  name,
  size = SIZES.mode,
  variant = VARIANTS.DOT,
  className,
}) {
  const key = name?.toLowerCase();
  const config = STATUS_CONFIG[key] || {};

  const Icon = () => {
    if (variant === VARIANTS.ARROW) {
      return (
        <span className={`status__arrow ${config.color}`}>
          <ArrowRightRounded
            size={Object.values(SIZES).find(({ mode }) => mode === size).value}
            fill="currentColor"
          />
        </span>
      );
    }

    if (config.dot) {
      return <span className={`status__dot ${config.color}`} />;
    }

    return null;
  };

  return (
    <div
      className={classNames(
        "status__wrapper",
        `status__wrapper--${size}`,
        `status__wrapper--${variant}`,
        className
      )}
    >
      {Icon()}
      <span className={`status__text ${config.color}`}>
        {config.label || name}
      </span>
    </div>
  );
}

export default Status;
